"use strict";
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import API_CONFIG from "./api.config";
import { logout, getToken, relogin } from "@/utils/auth";
import { commonError } from "./error";
// import store from "../store";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
let apiurl = process.env.NODE_ENV === "production" ? API_CONFIG.BASE_VIEWGRES_V4_API : API_CONFIG.BASE_VIEWGRES_V4_API;

let config = {
    baseURL: apiurl,
    timeout: 60 * 5000, // Timeout
    // withCredentials: true, // Check cross-site Access-Control
};

const baseApi = axios.create(config);

baseApi.interceptors.request.use(
    config => {

        if (getToken()) {
            config.headers.Authorization = getToken();
            // config.headers['referrerPolicy'] = "no-referrer-when-downgrade";
        }


        return config;
    },
    error => {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
baseApi.interceptors.response.use(
    response => {

        if (response.data.status) {
            if (response.data.status === 401) {
                commonError("401错误", response.data)
                logout()
            }
            if (response.data.status === 404) {
                commonError("404错误", response.data)
            }
            if (response.data.status === 500) {
                commonError("服务器错误", response.data)
            }
            return Promise.reject(response.data);
        } else {
            return response;
        }
    },
    error => {
        if (error.response) {

            if (error.response.data.status === 401) {
                commonError("401错误", error.response.data)
                logout()
                // relogin()
            }
            if (error.response.data.status === 404) {
                commonError("404错误", error.response.data)
            }
            if (error.response.data.status >= 500) {
                commonError("服务器错误", error.response.data)
            }
            return Promise.reject(error.response.data);
        }

        return Promise.reject(error);
    }
);
export {
    baseApi
}

Plugin.install = function (Vue, options) {
    Vue.baseApi = baseApi;
    window.baseApi = baseApi;
    Object.defineProperties(Vue.prototype, {
        baseApi: {
            get() {
                return baseApi;
            }
        },
        $baseApi: {
            get() {
                return baseApi;
            }
        }
    });
};

Vue.use(Plugin);

export default Plugin;
